<template>
  <v-container grid-list-md fluid fill-height overflow-y>
    <v-layout row wrap>
      <Header
        :lingronCounter="lingronCounter"
        :stepCounter="stepCounter"
        :maxLingron="maxLingron"
        fromStepField="false"
      />

      <v-flex xs12 text-xs-center class="lingronTipps">
        <!-- <v-layout row wrap>
                    <v-flex xs11> -->
        <h3 class="bolder">
          <p v-show="!tipp_icon" v-html="tipp"></p>

          <p v-show="tipp_icon">
            Kattints a
            <v-btn color="info" fab small>
              <v-icon>help</v-icon>
            </v-btn>
            ikonra
          </p>

          <!-- <v-btn
                                v-if="lessonId === 4"
                                color="info"
                                fab
                                small
                                @click="modal.show = true"
                                >
                                <v-icon>info</v-icon>
                            </v-btn> -->
        </h3>
        <h4>
          {{ tipp2 }}
        </h4>
        <!-- </v-flex>
                    <v-flex xs1 class="text-xs-left"> -->
        <!-- </v-flex>
                </v-layout> -->
      </v-flex>

      <transition name="fadeFast" height="100px">
        <v-flex v-show="playShow" xs12 class="text-xs-center ">
          <v-btn
            @click="showOtherWord"
            color="#421773"
            class="text-center float-center text-white playButtonSize"
            fab
            title="Üzenetek"
            elevation="5"
            x-large
            :class="{ pulsePlayButton: playedNow }"
          >
            <v-icon>
              volume_up
            </v-icon>
          </v-btn>
          <!--<div-->
          <!--  @click="showOtherWord"-->
          <!--  class="playButton playButtonLingron text-center float-center"-->
          <!--  :class="{ pulsePlayButton: voiceShow }"-->
          <!--&gt;</div>-->
        </v-flex>
      </transition>

      <v-flex xs12>
        <v-layout row wrap text-xs-center align-center class="lingronContainer">
          <!-- <v-flex xs12 text-xs-center>
                        <transition name="glide">
                            <div v-show="showStepEffect" style="height: 0px;">
                                <img :src="require('@/assets/img/footprint_mod_2.png')" height="75px" />
                            </div>
                        </transition>
                    </v-flex> -->

          <v-flex xs12 offset-md2 md8 text-xs-center>
            <transition name="fadeFast">
              <v-card
                v-show="lingron.showOtherLang"
                @click="showMainWord"
                class="lingronWord mb-3"
                :class="lingronOtherClass"
                style="position: relative;"
              >
                {{ lingron.other_lang }}

                <transition name="fadeSlow">
                  <v-btn
                    v-show="lingron.showMainLang && hasMiniLingrons"
                    color="info"
                    fab
                    small
                    @click="showMiniLingrons = true"
                    style="position: absolute; z-index: 2; right: 0; top: 0;"
                  >
                    <v-icon>help</v-icon>
                  </v-btn>
                </transition>
              </v-card>
            </transition>

            <transition name="fadeFast">
              <v-card
                v-show="lingron.showMainLang"
                @click="showNext"
                class="lingronWord"
                :class="lingronMainClass"
              >
                {{ lingron.main_lang }}
              </v-card>
            </transition>
          </v-flex>

          <!-- <v-flex xs12 text-xs-center>
                        <transition name="glide">
                            <div v-show="showLingronEffect" style="height: 0px;">
                                <img :src="require('@/assets/img/new_lingron_mod_2.png')" height="75px" />
                            </div>
                        </transition>
                    </v-flex> -->
        </v-layout>
      </v-flex>

      <v-dialog v-model="modal.show" width="600">
        <v-card>
          <v-card-title class="headline mainPurple dark text-light">
            Lingronok

            <v-spacer></v-spacer>

            <v-btn color="error" fab small @click="modal.show = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="modal.show = false">
            <p>
              LINGRON = apró nyelvi panel, építőkocka. <br />
              A lingronokkal apró részletekre bontjuk előtted a mondatokat
              azért, hogy könnyen tudd használni őket az életben. <br />
              A LINGRON nevet mi találtuk ki. A lingo (nyelv) és neuron
              (idegsejt) szavakból áll össze. <br />
              Mivel a rövid nyelvi panelekkel elvégzett repetitív gyakorlatok
              során új idegsejt-hálózat keletkezik az agyban, <br />
              így azt gondoltuk, ez egy találó név. Minél több LINGRON-t
              gyűjtesz be, annál több idegsejt áll a nyelvtudásod szolgálatába.
              <br />
              Egy leckében átlag 30-40 lingront gyűjthetsz be.
            </p>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="error" dark @click="modal.show = false">
                  Bezár
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showTipp" width="600">
        <v-card>
          <v-card-title
            class="headline mainPurple dark text-light"
            primary-title
          >
            Segítség
            <v-spacer></v-spacer>
            <v-btn color="error" fab small @click="showTipp = false">
              <v-icon class="text-light">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text @click="showTipp = false">
            <img
              :src="require('@/assets/img/middle_step2.png')"
              alt="help"
              class="img-responsive"
            />
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="error" dark @click="showTipp = false">
                  Bezár
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showMiniLingrons" width="100%">
        <v-card>
          <v-card-title class="headline mainPurple dark text-light">
            Gondold ki - kattints rá

            <v-spacer></v-spacer>

            <!-- <v-btn color="error" fab small @click="showMiniLingrons = false">
                            <v-icon class="text-light">close</v-icon>
                        </v-btn> -->
          </v-card-title>

          <v-card-text class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 mb-1>
                <v-card
                  v-for="(miniLingron, index) in miniLingrons"
                  :key="index"
                  dark
                  class="bgMiniLingronColor m-3 p-2 text-xs-center overViewLingron pilled"
                  :class="{ bgLingronHeardColor: miniLingron.showOther }"
                  @click="miniLingronClick(miniLingron)"
                >
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div v-if="!miniLingron.showOther" class="pa-1">
                        {{ miniLingron.other_lang }}
                        <!--{{ miniLingron.main_lang }}-->

                        <div v-if="miniLingron.file !== null">
                          <v-icon v-if="!miniLingron.played"
                            >volume_mute</v-icon
                          >
                          <v-icon v-else>volume_up</v-icon>
                        </div>
                      </div>
                      <div v-else class="pa-1">
                        {{ miniLingron.main_lang }}
                        <!--{{ miniLingron.other_lang }}-->
                        <div v-if="miniLingron.file !== null">
                          <v-icon v-if="!miniLingron.played"
                            >volume_mute</v-icon
                          >
                          <v-icon v-else>volume_up</v-icon>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-actions class="text-xs-center">
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-btn color="error" dark @click="showMiniLingrons = false">
                  Tovább
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- <v-spacer></v-spacer> -->

      <!-- <v-flex xs12 class="mt-md-5 pt-md-5 align-self-center text-center">
            <v-divider></v-divider> -->

      <!-- <v-layout row wrap v-bind:class="{ bgBlue: nextStep }">
              <v-flex xs12 v-if="nextStep" @click="goToNext">
                <v-btn large dark flat>
                  Következő
                  <v-icon right dark>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-flex>

              <v-flex xs12 v-else>
                <v-btn large disabled>
                  Következő
                  <v-icon right dark>keyboard_arrow_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout> -->
      <!-- </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { setTimeout } from "timers";
import Header from "@/components/partials/Header";

export default {
  components: {
    Header
  },
  data: function() {
    return {
      questionId: this.$route.params.questionId,
      // lessonId: this.$route.params.lessonId,
      lessonId: this.$store.getters.currentLessonId,
      stepImg: this.$store.getters.getApiUrl + "/uploads/step2_45.png",
      lingronImg: this.$store.getters.getApiUrl + "/uploads/lingron_45.png",
      progressIndicator: this.$store.getters.getProgressIndicator,
      lingron: "",
      miniLingrons: "",
      hasMiniLingrons: false,
      showMiniLingrons: false,
      file: "",
      earnLingron: true,
      lingronMainClass: "lingronWordMain",
      lingronOtherClass: "lingronWordOther",
      last: false,
      nextStep: false,
      lastQuestion: this.$store.getters.getLastQuestion,
      lastQuestionState: this.$store.getters.getLastQuestionState,
      stepCounter: this.$store.getters.getStepCounter,
      lingronCounter: this.$store.getters.getLingronCounter,
      maxLingron: this.$store.getters.getMaxLingron,
      tipp: "Hallgasd meg a mondatot!",
      tipp2: "",
      tipp_icon: false,
      showLingronEffect: false,
      showStepEffect: false,
      playedFile: "",
      playedNow: false,
      playSound2: true,
      playShow: true,
      voiceShow: false,
      modal: {
        show: false
      },
      showTipp: false
    };
  },
  methods: {
    getLingronData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/lingron", {
          token: this.$store.getters.getToken,
          questionId: this.$data.questionId,
          lastLingron: this.$store.getters.getLastLingron
        })
        .then(response => {
          // console.log("lingron - resp: ", response.data);
          // console.log("lingron - lastLingron: ", this.$store.getters.getLastLingron);

          this.$data.lingron = response.data.lingron;
          this.$data.last = response.data.last;
          this.$data.file = response.data.file;
          this.$data.miniLingrons = response.data.lingron.miniLingrons;
          this.$data.hasMiniLingrons = response.data.lingron.hasMiniLingrons;
          this.$data.showMiniLingrons = response.data.lingron.showMiniLingrons;
          this.$data.file = response.data.file;

          //Set component default states
          this.$data.earnLingron = true;
          this.$data.playSound2 = true;
          this.$data.playShow = true;
          this.$data.nextStep = false;
          this.$data.lingronMainClass = "lingronWordMain";
          this.$data.lingronOtherClass = "lingronWordOther";

          // if( this.$data.questionId === 406 && this.$store.getters.getLastLingron === null )
          // {
          //     this.$data.showTipp = true;
          // }

          //Store last lingron
          this.$store.commit("updateLastLingron", {
            lastLingronId: response.data.lingron.id
          });
        })
        .catch(error => {
          if (error.length > 0) {
            console.log("lingron - error: ", error);
          }
        });
    },
    showOtherWord() {
      //Lets play a sound file
      if (
        this.$data.file !== undefined &&
        this.$data.file !== null &&
        this.$data.playSound2
      ) {
        // let sound = this.$store.getters.getApiUrl+'/uploads/sound/'+this.$data.file.filename;
        // var audio = new Audio(sound);
        // audio.play();

        this.playSound(this.$data.file);

        //this.$data.playedFile = audio;
        this.$data.voiceShow = true;
        this.$data.playSound2 = false; // Can't play sound again, while animations playing

        //Increment the stepCounter
        this.$data.stepCounter++;

        //Store the new stepCounter
        this.$store.commit("updateStepCounter", {
          stepCounter: this.$data.stepCounter
        });

        // this.$data.showStepEffect = true; //Play the animation
      }

      let v = this;
      // setTimeout(function () {
      v.$data.showStepEffect = false; //Set animation default state
      // }, 800);

      //Wait for soud playing and  when finished, show the other_lang word
      setTimeout(function() {
        v.$data.lingron.showOtherLang = true; //Show the english word
        v.$data.playSound2 = true; //Enable play sound again
        v.$data.voiceShow = false;
      }, 2500);

      //Modify some data
      this.$data.tipp = "Gondold ki a magyar jelentést";
      this.$data.tipp2 = "Ha kigondoltad, kattints az angol szövegre";
    },
    playSound(file) {
      //console.log('playSound -  - ', this.$data.playedFile.length);
      if (file) {
        //Play the audio file
        let sound =
          this.$store.getters.getApiUrl + "/uploads/sound/" + file.filename;
        var audio = new Audio(sound);
        audio.load();

        if (!this.$data.playedNow) {
          this.$data.playedNow = true;
          this.$data.voiceShow = true;
          this.$data.isPlaying = true;
          this.$data.playedFile = audio;

          //Play sound
          audio.play();

          let v = this;
          setTimeout(function() {
            v.$data.playedNow = false;
            v.$data.voiceShow = false;
          }, 2700);
        }
      }
    },
    stopSound() {
      if (this.$data.playedFile !== null && this.$data.isPlaying) {
        // console.log('sound founded, I try to stop it.');

        //Stop the audio file
        var audio = this.$data.playedFile;
        audio.pause();
        this.$data.playedFile = null;
      }

      //Move to stepfield
      //this.$router.push({name: 'home'})
    },
    showMainWord() {
      this.$data.lingronOtherClass = "lingronWordOtherSuccess";
      this.$data.lingron.showMainLang = true;
      // this.$data.tipp = "Gyűjtsd be a lingront!";
      this.$data.tipp2 = "Továbblépéshez kattints a magyar szövegre";
      this.$data.tipp_icon = true;
    },
    showNext() {
      this.$data.tipp = "";
      this.$data.tipp2 = "";
      this.$data.tipp_icon = false;

      //Earn the lingron & sync
      if (this.$data.earnLingron) {
        // console.log('kapsz, egy lingront');

        //Increment the lingron
        this.$data.lingronCounter++;

        //Sync the current lingron
        this.$store.commit("updateLingronCounter", {
          lingronCounter: this.$data.lingronCounter
        });

        this.$data.lingronMainClass = "lingronWordMainSuccess";
        this.$data.earnLingron = false;
        // this.$data.showLingronEffect = false; //Set animation default state
      }

      //Stop the played file if it is already playing
      this.stopSound();

      //If it is the last lingron activate the next button
      if (this.$data.last) {
        //Go to the summery page
        //Move to conversation page if it is the last lingron of the last question in the lesson
        if (this.$data.last && this.$data.lastQuestionState) {
          this.$router.push({
            name: "conversation",
            params: { lessonId: this.$data.lessonId }
          });
        } //Move to next question if it is the last lingron but we have another question in the lesson
        else {
          this.$router.push({
            name: "question",
            params: { lessonId: this.$data.lessonId }
          });
        }
      } else {
        //If not is the last lingron load the next lingron

        this.$data.lingronMainClass = "lingronWordMainSuccess";
        this.$data.playSound2 = false; //Can't play sound, while loading the new
        this.$data.file = null;

        var v = this;
        setTimeout(function() {
          v.$data.showLingronEffect = false;
          //v.playNextLingronEffect(); - wont play the husssh sound
          v.$data.lingron.showOtherLang = false;
          v.$data.lingron.showMainLang = false;
          v.$data.playShow = false;

          v.$data.tipp = "Hallgasd meg a mondatot!";
          v.$data.tipp2 = "";
          v.getLingronData();
        }, 1000);
      }
    },
    goToNext() {
      // console.log('mehetunk tova');
      // console.log('Last Question State', this.$data.lastQuestionState);

      //Stop the played file if it is already playing
      this.stopSound();

      this.$data.tipp = "Lépj tovább az összesítő oldalra!";

      //Move to summery page if it is the last lingron of the last question in the lesson
      if (this.$data.last && this.$data.lastQuestionState) {
        //this.$router.push({name: 'home'});
        this.$router.push({
          name: "summary",
          params: { lessonId: this.$data.lessonId }
        });
      } //Move to next question if it is the last lingron but we have another question in the lesson
      else {
        this.$router.push({
          name: "question",
          params: { lessonId: this.$data.lessonId }
        });
      }
    },
    playNextLingronEffect() {
      let sound = require("@/assets/sound/swoosh.mp3");
      var audio = new Audio(sound);
      audio.play();
    },
    playCorrectEffect() {
      let sound = require("@/assets/sound/correct_answer.mp3");
      var audio = new Audio(sound);
      audio.play();
    },
    transformMiniLingron(miniLingron) {
      return (miniLingron.show = !miniLingron.show);
    },
    miniLingronClick(miniLingron) {
      // console.log('Mini lingron click fnc', miniLingron);

      //increase step & lingron counters
      this.$data.stepCounter++;
      this.$data.lingronCounter++;

      //Sync counters
      this.$store.commit("updateStepCounter", {
        stepCounter: this.$data.stepCounter
      });

      this.$store.commit("updateLingronCounter", {
        lingronCounter: this.$data.lingronCounter
      });

      //only show the main_word version
      miniLingron.showOther = !miniLingron.showOther;

      // Dont play sound in this version
      //miniLingron.played = true;

      let v = miniLingron;
      setTimeout(function() {
        v.played = false;
      }, 2700);

      this.playSound(miniLingron.file);
    }
  },
  created: function() {
    this.getLingronData();
  }
};
</script>
